import { cx } from './cx';

/** The Nurture mark (parent and clinician around a child) with the wordmark. */
export const Brand = ({ className = '', compact = false }: { className?: string; compact?: boolean }) => (
  <span className={cx('inline-flex items-center gap-2', className)}>
    <img src="/brand/logo-mark.png" srcSet="/brand/logo-mark.png 1x, /brand/logo-mark@2x.png 2x" alt="" width={36} height={36} className="h-9 w-9" />
    <span className="flex items-baseline gap-1.5">
      <span className="font-display text-[24px] font-extrabold leading-none text-lagoon-600">Nurture</span>
      {!compact && <span className="hidden text-caption text-ink-muted sm:inline">by ZenQuip</span>}
    </span>
  </span>
);
